import { CommonModule } from '@angular/common';
import { Injectable, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { UzurvDirectivesModule, UzurvPipesModule } from '@uzurv/core';
import { MaterialModule } from '../../app/material.module';
import { FilterModule } from '../filter/filter.module';
import { SubstanceScreeningModule } from '../substance-screening/substance-screening.module';
import { GenericListButtonComponent } from './generic-list-button/generic-list-button.component';
import { GenericListIconComponent } from './generic-list-icon';
import { GenericListIconButtonComponent } from './generic-list-icon-button';
import { GenericListLinkComponent } from './generic-list-link';
import { GenericListInputComponent } from './generic-list-input/generic-list-input.component';
import { GenericListMenuComponent } from './generic-list-menu';
import { GenericListSelectComponent } from './generic-list-select';
import { GenericListSlideToggleComponent } from './generic-list-slide-toggle/generic-list-slide-toggle.component';
import { GenericListComponent } from './generic-list.component';

@Injectable()
export class MatPaginatorIntlNoLength extends MatPaginatorIntl {
  itemsPerPageLabel = 'Items per page:';
  nextPageLabel = 'Next page';
  previousPageLabel = 'Previous page';

  getRangeLabel = (page: number, pageSize: number, length: number) => {
    if (length === 0 || pageSize === 0) {
      return `0 of ${Math.max(length, 0)}`;
    }

    const totalItems = Math.max(length, 0);
    const startIndex = page * pageSize;

    if (startIndex >= totalItems) {
      return `${startIndex + 1} - ${startIndex + pageSize}`;
    }

    const endIndex = Math.min(startIndex + pageSize, totalItems);
    return `${startIndex + 1} - ${endIndex}`;
  };
}

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    FilterModule,
    UzurvDirectivesModule,
    UzurvPipesModule,
    SubstanceScreeningModule
  ],
  declarations: [
    GenericListComponent,
    GenericListButtonComponent,
    GenericListIconComponent,
    GenericListIconButtonComponent,
    GenericListInputComponent,
    GenericListMenuComponent,
    GenericListSelectComponent,
    GenericListMenuComponent,
    GenericListLinkComponent,
    GenericListSlideToggleComponent
  ],
  exports: [GenericListComponent]
})
export class GenericListModule {}
